import type { PageHelp } from '../network-help.data';

export const L10N_fa_g4: Record<string, PageHelp> = {
  'trains-ticket': {
    title: 'بلیت قطار',
    tag: 'بلیت الکترونیکی صادرشده',
    tagline: 'بلیت الکترونیکی صادرشده ریلی — شماره رزرو، واگن / صندلی، QR و سود فروش.',
    business: {
      lead: 'این سند اثبات فروش ریلی است — شماره رزرو و QR / بارکدی که مسافر برای سوار شدن اسکن می‌کند، به‌همراه واگن و صندلی تأییدشده. همچنین چرخه تجاری را می‌بندد و حاشیه سود محقق‌شده روی رزرو را به کارگزار نشان می‌دهد.',
      points: [
        { title: 'سوار شدن با QR', desc: 'شماره رزرو و بارکد همان چیزی است که مسافر برای سوار شدن ارائه می‌دهد.' },
        { title: 'واگن و صندلی تأییدشده', desc: 'واگن و صندلی دقیق (و جهت / وضعیت آن) روی بلیت درج شده است.' },
        { title: 'سود محقق می‌شود', desc: 'خلاصه مالی، حاشیه سود این فروش را شفاف می‌کند.' },
      ],
    },
    software: {
      lead: 'یک بلیت با مسیر سفر، واگن / صندلی و اطلاعات مالی.',
      points: [
        { title: 'سربرگ و نوار مسافر', desc: 'شماره رزرو، نام مسافر، شماره بلیت، کلاس و تاریخ صدور.' },
        { title: 'مسیر و صندلی', desc: 'اپراتور، شماره سرویس، ایستگاه‌های مبدأ / مقصد و مدت سفر، به‌همراه ردیف واگن / صندلی و بارکد.' },
        { title: 'اطلاعات مالی و اقدامات', desc: 'نوار کناری حاشیه سود به‌همراه کنترل‌های ایمیل / کپی / اصلاح / استرداد.' },
      ],
    },
    related: ['trains-payment', 'bookings', 'booking-detail', 'refunds'],
  },

  'hotels-results': {
    title: 'نتایج هتل',
    tag: 'جستجوی هتل',
    tagline: 'اقامتگاه‌های موجود برای اقامت، رتبه‌بندی‌شده — با نمایش شیوه فروش و سیاست استرداد پیش از تعهد.',
    business: {
      lead: 'صفحه نتایج هر اقامتگاه قابل رزرو برای جستجو را نشان می‌دهد و موجودی قراردادی خودی را با تأمین متصل ترکیب می‌کند. نشان‌هایی که از نظر تجاری اهمیت دارند — آنی در برابر درخواستی، قابل‌استرداد در برابر غیرقابل‌استرداد — روی کارت درج شده‌اند، تا کارگزار با آگاهی از نحوه و زمان تأیید رزرو و جابه‌جایی پول انتخاب کند.',
      points: [
        { title: 'ادغام تأمین خودی و متصل', desc: 'اتاق‌های ماژول اقامتگاه هتل پلتفرم و تأمین‌کنندگان بیرونی در یک فهرست واحد رتبه‌بندی می‌شوند.' },
        { title: 'شیوه فروش قابل مشاهده است', desc: 'آنی با یک کلیک تأیید می‌شود؛ درخواستی رزرو را تا پذیرش تأمین‌کننده نگه می‌دارد — نشان به کارگزار می‌گوید کدام را دریافت می‌کند.' },
        { title: 'سیاست استرداد از ابتدا', desc: 'لغو رایگان در برابر غیرقابل‌استرداد هم فیلتر است و هم برچسب، تا کارگزار سیاست درست را اعلام کند.' },
      ],
    },
    software: {
      lead: 'فهرست قابل‌فیلتر اقامتگاه‌ها با نوار نرخ و کشوی انتخاب اتاق.',
      points: [
        { title: 'فیلتر اقامتگاه‌ها', desc: 'نوار کناری بر اساس مرتب‌سازی، رتبه ستاره، بازه قیمت، سیاست استرداد، منطقه و تأمین‌کننده و نیز جستجوی متن آزاد روی نام / منطقه / زنجیره محدود می‌کند.' },
        { title: 'مرور نوار نرخ', desc: 'تقویم قیمت شبانه ۷ روزه پیرامون تاریخ ورود؛ روی تاریخ کلیک کنید تا دوباره جستجو شود.' },
        { title: 'انتخاب اتاق برای رزرو', desc: 'کارت‌ها بهترین نرخ شبانه در برابر نرخ رسمی، امتیاز بازبینی و برچسب استرداد را نشان می‌دهند؛ «انتخاب اتاق» کشوی رزرو را باز می‌کند.' },
      ],
    },
    flow: {
      lead: 'از صفحه نتایج، رزرو در یک کشو (نه صفحات جداگانه) که به واچر ختم می‌شود، تکمیل می‌گردد.',
      steps: [
        { title: 'انتخاب اتاق و نرخ', desc: 'یک نوع اتاق و طرح نرخ انتخاب کنید؛ مجموع، تمام شب‌ها به‌همراه مالیات را پوشش می‌دهد و سیاست استرداد نمایش داده می‌شود.' },
        { title: 'مشخصات مهمان', desc: 'یک فرم برای هر مهمان در هر اتاق (عنوان، نام، تاریخ تولد، ملیت، پاسپورت)؛ مشتری ذخیره‌شده از CRM پیش‌پر می‌شود. مهمان اصلی، مخاطب رزرو را بر عهده دارد.' },
        { title: 'پرداخت (+ افزودنی‌ها)', desc: 'روش پرداخت را انتخاب کنید؛ روی موجودی خودی می‌توان خدمات جانبی اختیاری (پارکینگ، اسپا…) را اینجا افزود.' },
        { title: 'بازبینی و تأیید', desc: 'خلاصه نهایی اتاق‌ها، مهمانان و مجموع؛ با تأیید، سفارش ایجاد و واچر صادر می‌شود.' },
      ],
    },
    related: ['hotels-search', 'hotels-ticket', 'supply-properties', 'markup'],
  },

  'hotels-ticket': {
    title: 'واچر هتل',
    tag: 'واچر صادرشده',
    tagline: 'واچر تأییدشده هتل — اقامتگاه، تاریخ‌های اقامت، فهرست مهمانان و هزینه‌ها.',
    business: {
      lead: 'واچر، سند اثبات اقامت تأییدشده برای مهمان و سندی است که هتل هنگام ورود آن را می‌پذیرد. این سند، اقامتگاه، طرح نرخ و وعده غذایی، تاریخ‌های ورود / خروج و مدرک هر مهمان را در یک رکورد واحد که آژانس می‌تواند ایمیل یا چاپ کند، یکپارچه می‌کند.',
      points: [
        { title: 'اثبات برای ورود', desc: 'شماره رزرو به‌همراه فهرست مهمانان هر اتاق (با مدارک) همان چیزی است که هتل هنگام ورود بررسی می‌کند.' },
        { title: 'وعده غذایی و استرداد در سند', desc: 'وعده غذایی طرح نرخ و سیاست لغو روی واچر ذکر شده، نه پنهان در یک قرارداد.' },
        { title: 'خدمات‌رسانی از اینجا', desc: 'برنامه سفر را ایمیل کنید، شماره رزرو را کپی کنید، یا رزرو را اصلاح / لغو کنید.' },
      ],
    },
    software: {
      lead: 'واچری با اقامتگاه، نوار اقامت، فهرست مهمانان هر اتاق و هزینه‌ها.',
      points: [
        { title: 'سربرگ و اقامتگاه', desc: 'نشان «واچر صادر شد» و شماره رزرو، اقامتگاه با برچسب‌های تأییدشده / وعده غذایی / استرداد، و ایمیل / چاپ / دانلود.' },
        { title: 'نوار اقامت', desc: 'تاریخ ورود (از ساعت ۱۵:۰۰)، تعداد شب‌ها، و خروج (تا ساعت ۱۲:۰۰).' },
        { title: 'مهمانان و هزینه‌ها', desc: 'فهرست مهمانان هر اتاق با مدارک، به‌همراه نوار کناری هزینه‌ها (نرخ پایه اتاق، مالیات، مجموع).' },
      ],
    },
    related: ['hotels-results', 'bookings', 'booking-detail'],
  },

  'tours-new': {
    title: 'سازنده بسته تور',
    tag: 'ساخت بسته',
    tagline: 'یک بسته چندخدمتی بسازید — برنامه سفر، پروازها، هتل‌ها، شمول‌ها و قیمت‌گذاری بر اساس ظرفیت — سپس آن را برای فروش منتشر کنید.',
    business: {
      lead: 'این سمت تأمین تورها است: جایی که اپراتور محصولی می‌سازد که کارگزاران بعداً می‌فروشند. یک بسته، پروازها، هتل‌ها، ترانسفرها و فعالیت‌ها را در یک SKU با برنامه سفر، بازه حرکت و قیمت بسته‌ای خاص خود گرد می‌آورد — تا بتوان آن را با یک قیمت سرتیتر بازاریابی کرد و حاشیه سودش را به‌صورت یکپارچه مدیریت کرد، نه خط‌به‌خط.',
      points: [
        { title: 'یک SKU، اجزای متعدد', desc: 'پروازها و یک هتل همیشه شامل هستند؛ ویزا، ترانسفرها و بیمه کلیدهای اختیاری‌اند — همه به‌عنوان یک رکورد واحد فروخته می‌شوند.' },
        { title: 'قیمت‌گذاری بر اساس ظرفیت', desc: 'هر سبد هتل بر اساس نقش‌های ظرفیت (بزرگسال، بزرگسال-تک، کودک-با تخت، کودک-بدون تخت، نوزاد) قیمت‌گذاری می‌شود، تا یک خانواده یا یک مسافر تنها هرکدام قیمت درست را دریافت کنند.' },
        { title: 'وضعیت انتشار، فروش را کنترل می‌کند', desc: 'یک بسته از غیرفعال ← پیش‌نمایش ← فعال حرکت می‌کند؛ تنها حرکت‌های فعال (نه گذشته) از صفحه تورها قابل رزرو هستند.' },
      ],
    },
    software: {
      lead: 'یک راهنمای گام‌به‌گام از اطلاعات پایه تا انتشار، که هر گام پیش از پیشروی اعتبارسنجی می‌شود.',
      points: [
        { title: 'پایه، برنامه سفر، اجزا', desc: 'نام، شهرها، تاریخ‌ها، دسته و نشان‌ها؛ برنامه روزبه‌روز با شهر اقامت شبانه هر روز؛ و فهرست شامل / مستثنی از کاتالوگ یا متن آزاد.' },
        { title: 'پروازها و سبدهای هتل', desc: 'یک پرواز پیوست کنید (جستجو و رزرو در حالت تور، یا دستی) و سبدهای هتل چندشهری بسازید (شهر + هتل + اتاق).' },
        { title: 'قیمت‌گذاری و انتشار', desc: 'یک ماتریس قیمت هر سبد × هر ظرفیت، سپس انتشار با کلیدهای توزیع (ویژه، ایمیل هفتگی، محدودیت بازار، برچسب سفید B2C).' },
      ],
    },
    related: ['tours', 'flights-search', 'hotels-search', 'supply-properties'],
  },

  visa: {
    title: 'ویزا',
    tag: 'خدمات ویزا',
    tagline: 'درخواست‌های ویزای قابل رزرو با کاتالوگ، واجد شرایط بودن و میز کار کارشناس در پشت باجه.',
    business: {
      lead: 'ویزا، پردازش مجوز ورود را به یک خدمت قابل رزرو تبدیل می‌کند. آژانس ویزا را همان‌طور که یک پرواز یا هتل می‌فروشد، می‌فروشد — به‌عنوان محصولی با قیمت، زمان آماده‌سازی و تحویل مشخص — با یک جریان کارشناسی پشت صحنه که واقعاً مدارک را جمع می‌کند، به سفارتخانه ارسال می‌کند و تصمیم را بازمی‌گرداند.',
      points: [
        { title: 'ویزا یک محصول است', desc: 'هر مقصد × نوع ویزا یک ورودی کاتالوگ با قیمت‌گذاری، زمان آماده‌سازی و الزامات مدارک دارد؛ نرخ افزوده آژانس روی آن قرار می‌گیرد.' },
        { title: 'واجد شرایط بودن، فروش را کنترل می‌کند', desc: 'ملیت مسافر، هدف سفر و بازه اعتبار تعیین می‌کند کدام ورودی‌های کاتالوگ واقعاً قابل فروش هستند — جستجو تنها ترکیب‌های معتبر را پیشنهاد می‌دهد.' },
        { title: 'پول دریافت، خدمت تحویل می‌شود', desc: 'پرداخت هنگام رزرو گرفته می‌شود؛ میز کار کارشناس پیشرفت را از دریافت مدارک تا بازگشت تصمیم دنبال می‌کند.' },
      ],
    },
    software: {
      lead: 'جستجوی کاتالوگ ویزا به‌همراه یک میز کار کارشناس پشتیبان برای سمت انجام کار.',
      points: [
        { title: 'جستجوی کاتالوگ', desc: 'مقصد، نوع ویزا و ملیت مسافر نتایج را هدایت می‌کنند؛ تنها ترکیب‌های قابل فروش نمایش داده می‌شوند.' },
        { title: 'رزرو ویزا', desc: 'انتخاب یک ورودی، فرم مسافر / بارگذاری مدارک و پرداخت را باز می‌کند؛ نتیجه یک رزرو ویزا است.' },
        { title: 'پیگیری تا تحویل', desc: 'میز کار کارشناس هر پرونده باز، مرحله، مدارک و وضعیت سمت سفارتخانه آن را نشان می‌دهد — کارگزار از این برای به‌روزرسانی مشتری استفاده می‌کند.' },
      ],
    },
    flow: {
      lead: 'یک رزرو ویزا دو نیمه دارد — فروش رو به مشتری، سپس انجام کار پشتیبان تا تصمیم.',
      steps: [
        { title: 'فیلتر کاتالوگ', desc: 'کشور مقصد، نوع ویزا (توریستی / تجاری / ترانزیت / دانشجویی) و ملیت مسافر، واجد شرایط بودن را هدایت می‌کنند؛ ترکیب‌های فاقد شرایط پنهان می‌شوند.' },
        { title: 'مطالعه ورودی', desc: 'هر ورودی کاتالوگ، هزینه، زمان آماده‌سازی، الزامات مدارک و کانال تصمیم سفارتخانه را نشان می‌دهد.' },
        { title: 'ثبت مسافر', desc: 'مشخصات مسافر (پاسپورت، تاریخ‌های سفر، هدف، جزئیات پشتیبان) پرونده را هدایت می‌کند.' },
        { title: 'بارگذاری مدارک', desc: 'اسکن پاسپورت، عکس، دعوت‌نامه، مدرک مالی — مجموعه موردنیاز بسته به ورودی کاتالوگ متفاوت است.' },
        { title: 'پرداخت و باز کردن پرونده', desc: 'پرداخت هنگام رزرو دریافت می‌شود. پرونده در میز کار کارشناس در مرحله «مدارک دریافت شد» باز می‌شود.' },
        { title: 'انجام کار توسط کارشناس', desc: 'کارشناس مدارک را بررسی می‌کند، به سفارتخانه ارسال می‌کند، وضعیت را دنبال می‌کند، تصمیم را دریافت می‌کند و پرونده را با سند ویزا یا رد درخواست می‌بندد.' },
        { title: 'تحویل به مشتری', desc: 'سند ویزا (یا توضیح رد درخواست) به رزرو پیوست می‌شود و برای اشتراک‌گذاری در اختیار کارگزار قرار می‌گیرد.' },
      ],
    },
    modes: {
      lead: 'ورودی‌های ویزا بر اساس نوع ویزا کاتالوگ‌بندی می‌شوند؛ جریان بر اساس هر نوع تطبیق می‌یابد.',
      modes: [
        { name: 'Tourist', when: 'سفر تفریحی', desc: 'ویزای بازدیدکننده استاندارد. هزینه کمتر، زمان آماده‌سازی سریع‌تر در بیشتر مقصدها. مجموعه مدارک معمولاً پاسپورت + عکس + برنامه سفر است.' },
        { name: 'Business', when: 'بازدیدهای کاری / کنفرانس', desc: 'به دعوت‌نامه از سازمان میزبان نیاز دارد. هزینه بالاتر، زمان آماده‌سازی مشابه، گاهی وقت حضوری در سفارتخانه.' },
        { name: 'Transit', when: 'توقف در مقصد', desc: 'کوتاه‌ترین اعتبار، ارزان‌ترین هزینه. تنها برای بازه ترانزیت معتبر است. همه مقصدها آن را ارائه نمی‌دهند؛ جستجو آن‌ها را متناسب فیلتر می‌کند.' },
        { name: 'Student', when: 'پذیرش رسمی در یک مؤسسه محلی', desc: 'به مدرک پذیرش و اغلب یک تضمین مالی نیاز دارد. بلندترین زمان آماده‌سازی؛ بالاترین هزینه. میز کار کارشناس چرخه مدارک طولانی‌شده را دنبال می‌کند.' },
      ],
    },
    examples: [
      {
        title: 'ویزای توریستی ترکیه · ۱ مسافر · زمان آماده‌سازی ۲۱ روزه',
        rows: [
          { label: 'هزینه سفارتخانه', value: '4,500,000' },
          { label: 'کارمزد خدمت (پردازش آژانس)', value: '1,500,000' },
          { label: 'Retail MARKUP · +۱۰٪ از ناخالص', value: '+600,000', accent: 'success' },
          { label: 'مجموع مسافر', value: '6,600,000', strong: true },
        ],
        note: 'هزینه سفارتخانه عبوری است؛ آژانس روی کارمزد خدمت و نرخ افزوده خرده‌فروشی حاشیه سود می‌گیرد، نه روی هزینه سفارتخانه.',
      },
    ],
    related: ['flights-search', 'reference-data', 'markup'],
  },

  cip: {
    title: 'CIP',
    tag: 'خدمات کنسیرژ فرودگاه',
    tagline: 'خدمات استقبال‌وهمراهی و کنسیرژ VIP فرودگاه که در کنار یک سفر فروخته می‌شوند.',
    business: {
      lead: 'CIP (شخص مهم تجاری) کنسیرژ فرودگاه است — خدمت استقبال‌وهمراهی که مشتری را هنگام ورود، ترانزیت یا خروج با یک همراه فرودگاهی جفت می‌کند. از نظر تجاری این یک افزودنی کوچک با حاشیه سود بالا است که آژانس می‌تواند به هر سفر واجد شرایط بچسباند و بیشتر به آژانس‌های بازفروشنده فروخته می‌شود تا مستقیم به مسافران.',
      points: [
        { title: 'درآمد جانبی', desc: 'انجام یک رزرو کنسیرژ ارزان است، حاشیه سود بالایی دارد و با فروش اصلی پرواز/هتل رقابت نمی‌کند — درآمد افزوده خالص.' },
        { title: 'تنها بازفروشنده', desc: 'کاتالوگ CIP به آژانس‌ها ارائه می‌شود (نه مشتریان) — این یک محصول عمده‌فروشی است که بازفروشنده آن را برای مشتری نهایی خود دوباره قیمت‌گذاری می‌کند.' },
        { title: 'متعلق به cip-service', desc: 'داده‌های کاتالوگ CIP متعلق به cip-service اختصاصی است، نه content-service، تا قیمت‌گذاری و موجودی مستقل از بقیه داده‌های مرجع مدیریت شوند.' },
      ],
    },
    software: {
      lead: 'یک صفحه جستجو و رزرو کاتالوگ کنسیرژ اختصاصی که با cip-service پشتیبانی می‌شود.',
      points: [
        { title: 'جستجوی کاتالوگ', desc: 'فرودگاه، نوع خدمت (ورود / خروج / ترانزیت) و تعداد مسافر نتایج را هدایت می‌کنند.' },
        { title: 'رزرو خدمت', desc: 'انتخاب یک خدمت، فرم مسافر و جریان پرداخت را باز می‌کند؛ نتیجه یک رزرو CIP است که در کنار سایر محصولات در همه رزروها ظاهر می‌شود.' },
        { title: 'قیمت‌گذاری سرتاسری', desc: 'پول هنگام رزرو دریافت می‌شود؛ تطبیق دفتری با پشته حسابداری در نقشه راه فاز ۳ قرار دارد.' },
      ],
    },
    flow: {
      lead: 'یک رزرو CIP کوتاه است — مسافر یک فرودگاه، یک لحظه (ورود / خروج / ترانزیت) و یک سطح خدمت انتخاب می‌کند.',
      steps: [
        { title: 'انتخاب فرودگاه', desc: 'کد فرودگاه تعیین می‌کند کدام شبکه همراه در دسترس است؛ همه فرودگاه‌ها پوشش ندارند.' },
        { title: 'انتخاب لحظه', desc: 'ورود، خروج یا ترانزیت — همراه برای هرکدام در نقاط مختلفی داخل ترمینال آغاز و پایان می‌یابد.' },
        { title: 'انتخاب سطح خدمت', desc: 'استقبال‌وهمراهی، VIP، یا دسترسی کامل به لانژ — هر سطح امتیازات بیشتری (فست‌ترک، خودروی برقی، زمان لانژ) گرد می‌آورد.' },
        { title: 'تنظیم مشخصات پرواز', desc: 'شماره پرواز و تاریخ تا همراه بتواند مسافر درست را ملاقات کند.' },
        { title: 'ثبت مسافران + پرداخت', desc: 'نام مسافران + پرداخت؛ همراه، تخصیص را دریافت می‌کند و مشتری تأییدیه‌ای با نقطه ملاقات دریافت می‌کند.' },
      ],
    },
    modes: {
      lead: 'CIP در یکی از سه لحظه سفر و در یکی از چند سطح خدمت خریداری می‌شود — کاتالوگ ماتریسی از آن‌ها است.',
      modes: [
        { name: 'Arrival', when: 'پرواز ورودی', desc: 'همراه، مسافر را در گیت / پل هوایی ملاقات می‌کند، امور اداره مهاجرت و بار را انجام می‌دهد و تا بیرون سالن اسکورت می‌کند. محبوب میان VIPها و بازدیدکنندگان اولیه.' },
        { name: 'Departure', when: 'پرواز خروجی', desc: 'همراه، مسافر را بیرون سالن ملاقات می‌کند، امور پذیرش و بازرسی امنیتی را انجام می‌دهد و تا گیت یا لانژ اسکورت می‌کند.' },
        { name: 'Transit', when: 'پرواز اتصالی', desc: 'همراه بین پروازها ملاقات می‌کند و انتقال بین ترمینال‌ها و گیت‌ها را انجام می‌دهد. به‌ویژه در اتصال‌های تنگ ارزشمند است.' },
        { name: 'Meet & Assist', when: 'سطح پایه', desc: 'یک همراه و کمک فیزیکی — خدمت اساسی.' },
        { name: 'VIP', when: 'سطح ممتاز', desc: 'فست‌ترک از اداره مهاجرت و بازرسی امنیتی، حمل با خودروی برقی داخل ترمینال، و گاهی دسترسی به لانژ را می‌افزاید.' },
      ],
    },
    examples: [
      {
        title: 'ورود DXB · VIP · ۲ مسافر',
        rows: [
          { label: 'کارمزد پایه همراه (هر مسافر) × ۲', value: '2,800,000' },
          { label: 'Wholesale MARKUP · +۸٪ (آژانس همراه)', value: '+224,000', accent: 'info' },
          { label: 'Retail MARKUP · +۱۵٪ از ناخالص', value: '+453,600', accent: 'success' },
          { label: 'مجموع مسافر', value: '3,477,600', strong: true },
        ],
        note: 'CIP یک افزودنی با حاشیه سود بالا است — نرخ افزوده ترکیبی ۲۰ تا ۳۰٪ اینجا عادی است، در برابر ۵ تا ۱۰٪ روی پروازها.',
      },
    ],
    related: ['flights-search', 'reference-data', 'markup'],
  },

  ground: {
    title: 'حمل‌ونقل زمینی',
    tag: 'خدمات زمینی',
    tagline: 'ترانسفرهای نقطه‌به‌نقطه، خدمات راننده و حمل‌ونقل جاده‌ای کوتاه‌برد.',
    business: {
      lead: 'حمل‌ونقل زمینی، بخش جاده‌ای یک سفر را می‌فروشد — ترانسفرهای فرودگاهی، دریافت با راننده، اجاره روزانه خودرو — به‌عنوان محصولی قابل رزرو. این همراهِ «رسیدن از الف به ب روی زمین» برای فروش پرواز یا هتل است و به آژانس امکان می‌دهد کل سفر مشتری را در یک سبد به پایان برساند.',
      points: [
        { title: 'سفر را می‌بندد', desc: 'مشتری‌ای که پیش‌تر یک پرواز و یک هتل با آژانس رزرو کرده، یک پرسش بدیهی بعدی دارد — چگونه از یکی به دیگری بروم. زمینی، آن را به‌صورت درون‌سازمانی پاسخ می‌دهد.' },
        { title: 'به یک پرواز می‌چسبد', desc: 'ترانسفرهای فرودگاهی معمولاً پس از انتخاب پرواز خریداری می‌شوند؛ زمان دریافت می‌تواند از زمان ورود پرواز به ارث برسد و تلاش اپراتور را کاهش دهد.' },
        { title: 'قیمت‌گذاری لایه‌ای اعمال می‌شود', desc: 'همان موتور Wholesale / Distribution / Retail که پرواز را قیمت‌گذاری می‌کند، خدمت زمینی را نیز قیمت‌گذاری می‌کند — یک قاعده محدود به شریک اینجا هم کار می‌کند.' },
      ],
    },
    software: {
      lead: 'یک جستجوی دریافت / تحویل با گزینه‌های کلاس خودرو و جریان رزرو.',
      points: [
        { title: 'ترکیب مسیر', desc: 'محل دریافت، محل تحویل، تاریخ و تعداد مسافر جستجو را هدایت می‌کنند؛ کلاس خودرو (سدان / شاسی‌بلند / ون) انتخاب را محدود می‌کند.' },
        { title: 'خواندن ردیف خودرو', desc: 'هر نتیجه، اپراتور، کلاس خودرو، قیمت و مدت تخمینی را نشان می‌دهد.' },
        { title: 'پیشروی به رزرو', desc: 'یک خودروی انتخاب‌شده فرم مشخصات مسافر / دریافت و پرداخت را باز می‌کند؛ رکورد به همه رزروها می‌پیوندد.' },
      ],
    },
    flow: {
      lead: 'یک رزرو زمینی کوتاه است و اغلب به یک پرواز موجود می‌چسبد — محل دریافت، تحویل، زمان‌بندی، کلاس خودرو.',
      steps: [
        { title: 'انتخاب دریافت + تحویل', desc: 'شهر به شهر، فرودگاه به هتل، یا نقطه‌به‌نقطه. دریافت فرودگاهی از یک پرواز منطبق در همان PNR پیش‌پر می‌شود.' },
        { title: 'انتخاب تاریخ + زمان', desc: 'زمان دریافت — برای ترانسفرهای فرودگاهی می‌تواند از زمان ورود پرواز به ارث برسد (تنظیم‌شده با یک بافر استاندارد).' },
        { title: 'انتخاب کلاس خودرو', desc: 'سدان برای تنها / زوج، شاسی‌بلند برای خانواده، ون برای یک گروه. کلاس خودرو، ظرفیت، بار و قیمت را هدایت می‌کند.' },
        { title: 'ثبت مسافران + پرداخت', desc: 'نام و تلفن مسافر اصلی + پرداخت؛ راننده اعزام می‌شود و مسافر مشخصات دریافت را دریافت می‌کند.' },
      ],
    },
    modes: {
      lead: 'خدمات زمینی بر اساس شکل سفر — یک ترانسفر یک‌باره یا یک اجاره پیوسته — و بر اساس کلاس خودرو تقسیم می‌شوند.',
      modes: [
        { name: 'ترانسفر فرودگاهی', when: 'پرواز ورودی / خروجی', desc: 'دریافت یک‌باره از فرودگاه به هتل (یا برعکس). ارزان‌ترین و رایج‌ترین. زمان‌بندی دریافت از زمان ورود پرواز به ارث می‌رسد.' },
        { name: 'نقطه‌به‌نقطه', when: 'شهر ← شهر یا جابه‌جایی بین‌شهری', desc: 'یک تحویل در جای دیگری از شهر یا منطقه. قیمت با فاصله تغییر می‌کند.' },
        { name: 'راننده / ساعتی', when: 'جلسات کاری / روز VIP', desc: 'راننده + خودرو برای یک بازه ساعتی رزرو‌شده. مسافر مسیر روز را تعیین می‌کند.' },
        { name: 'اجاره روزانه', when: 'گشت‌وگذار در یک روز کامل', desc: 'خودرو + راننده تمام‌روز، معمولاً با حداکثر کیلومتر مجاز. قیمت بالاتر از یک بازه ساعتی.' },
      ],
    },
    examples: [
      {
        title: 'فرودگاه DXB ← هتل · شاسی‌بلند · ۲ مسافر + بار',
        rows: [
          { label: 'نرخ پایه ترانسفر', value: '600,000' },
          { label: 'Wholesale MARKUP · +۵٪ (حاشیه اپراتور)', value: '+30,000', accent: 'info' },
          { label: 'Retail MARKUP · +۱۰٪ از ناخالص', value: '+63,000', accent: 'success' },
          { label: 'مجموع مسافر', value: '693,000', strong: true },
        ],
        note: 'یک خدمت زمینی که به PNR یک پرواز موجود چسبیده، رکورد رزرو را به اشتراک می‌گذارد — یک پرداخت، یک واچر، یک جریان استرداد.',
      },
    ],
    related: ['flights-search', 'buses-search', 'markup'],
  },

  sim: {
    title: 'سیم‌کارت',
    tag: 'ارتباط سفر',
    tagline: 'سیم‌کارت‌ها / eSIMهای فقط‌داده سفر که به‌عنوان افزودنی پولی به هر سفر خروجی فروخته می‌شوند.',
    business: {
      lead: 'سیم‌کارت‌ها یک طرح داده برای مقصد را در کنار خود سفر می‌فروشند. مشتری از هزینه‌های رومینگ می‌پرهیزد، آژانس یک حاشیه سود کوچک به دست می‌آورد، و انجام کار (ارسال سیم‌کارت فیزیکی، یا تحویل QR کد eSIM) آن‌قدر سبک است که بهای تمام‌شده کالا را پایین نگه می‌دارد.',
      points: [
        { title: 'یک افزودنی خالص', desc: 'حاشیه سود در هر واحد کوچک است اما هزینه پیوست ناچیز است؛ درآمد افزوده روی هر سفر تفریحی خروجی.' },
        { title: 'فیزیکی + eSIM', desc: 'سیم‌کارت‌های فیزیکی به یک آدرس تحویل و زمان آماده‌سازی نیاز دارند؛ eSIMها بلافاصله هنگام رزرو به‌صورت QR کد تحویل می‌شوند که جریان را تغییر می‌دهد.' },
        { title: 'محدود به مقصد', desc: 'هر طرح به یک کشور یا منطقه و یک سهمیه داده / بازه اعتبار گره خورده است — کاتالوگ ماتریسی از آن ترکیب‌ها است.' },
      ],
    },
    software: {
      lead: 'یک جستجوی مقصد + طرح که با کاتالوگ سیم‌کارت پشتیبانی می‌شود.',
      points: [
        { title: 'جستجوی کاتالوگ', desc: 'کشور مقصد و بازه اعتبار نتایج را هدایت می‌کنند؛ سهمیه داده بیشتر محدود می‌کند.' },
        { title: 'خواندن ردیف طرح', desc: 'هر ردیف، اپراتور، سهمیه داده، اعتبار و قیمت را نشان می‌دهد؛ نوع سیم‌کارت (فیزیکی در برابر eSIM) بر انجام کار اثر می‌گذارد.' },
        { title: 'رزرو طرح', desc: 'انتخاب یک طرح، فرم مشخصات مسافر / تحویل و پرداخت را باز می‌کند؛ رکوردهای eSIM فوری تحویل می‌شوند، سیم‌کارت‌های فیزیکی یک تحویل را زمان‌بندی می‌کنند.' },
      ],
    },
    flow: {
      lead: 'یک رزرو سیم‌کارت یکی از کوتاه‌ترین جریان‌های موجودی است — مقصد، سهمیه، نوع سیم‌کارت، تحویل.',
      steps: [
        { title: 'انتخاب مقصد', desc: 'کشور یا منطقه — کاتالوگ بر اساس منطقه پوشش نمایه شده، نه بر اساس اپراتور.' },
        { title: 'انتخاب بازه اعتبار', desc: 'طول سفر تعیین می‌کند کدام طرح‌ها اعمال می‌شوند — یک طرح ۷ روزه به یک سفر ۲۱ روزه نمی‌خورد.' },
        { title: 'انتخاب سهمیه', desc: 'بودجه داده (نامحدود / ۱۰ گیگابایت / ۲۰ گیگابایت) بیشتر محدود می‌کند؛ طرح‌های نامحدود معمولاً پس از سقف مصرف منصفانه سرعت را کاهش می‌دهند.' },
        { title: 'انتخاب نوع سیم‌کارت', desc: 'سیم‌کارت فیزیکی (نیازمند آدرس تحویل + زمان آماده‌سازی) یا eSIM (QR تحویل‌شده هنگام رزرو). سازگاری گوشی مسافر انتخاب را تعیین می‌کند.' },
        { title: 'ثبت + پرداخت', desc: 'مسافر + آدرس تحویل (تنها فیزیکی) + پرداخت. QR کد eSIM بلافاصله روی تأییدیه نمایش داده می‌شود؛ ارسال سیم‌کارت فیزیکی زمان‌بندی می‌شود.' },
      ],
    },
    modes: {
      lead: 'دو بُعد اهمیت دارد — انجام کار فیزیکی در برابر eSIM، و پوشش جغرافیایی.',
      modes: [
        { name: 'Physical SIM', when: 'گوشی مسافر از eSIM پشتیبانی نمی‌کند', desc: 'یک سیم‌کارت نانو / میکرو که به آدرس مسافر ارسال می‌شود (یا از یک باجه شریک دریافت می‌شود). در بیشتر مسیرها به ۳ تا ۵ روز زمان آماده‌سازی نیاز دارد، پس زود رزرو کنید.' },
        { name: 'eSIM', when: 'گوشی مسافر از eSIM پشتیبانی می‌کند (بیشتر گوشی‌های هوشمند مدرن)', desc: 'QR کد هنگام رزرو تحویل می‌شود — بدون ارسال، بدون زمان آماده‌سازی. مسافر هنگام ورود اسکن می‌کند و پروفایل فعال می‌شود. بهای تمام‌شده کالای صفر برای آژانس.' },
        { name: 'Country-specific', when: 'سفر تک‌مقصدی', desc: 'طرح در یک کشور معتبر است. ارزان‌ترین نرخ به‌ازای هر گیگابایت.' },
        { name: 'Regional', when: 'سفر چندکشوری (مثلاً جابه‌جایی در اروپا)', desc: 'طرح در یک منطقه مشخص معتبر است (سراسر اتحادیه اروپا، آسیا-اقیانوسیه، شورای همکاری خلیج فارس). نرخ بالاتر به‌ازای هر گیگابایت اما بدون نیاز به تعویض سیم‌کارت در هر مرز.' },
        { name: 'Global', when: 'سفر بلند چندمنطقه‌ای', desc: 'طرح در فهرست گسترده‌ای از کشورها معتبر است — بیش از ۱۰۰ کشور. بالاترین نرخ به‌ازای هر گیگابایت؛ مناسب دور دنیا یا مسافران کاری.' },
      ],
    },
    examples: [
      {
        title: 'ترکیه · ۱۰ روزه ۱۰ گیگابایت · eSIM · ۱ مسافر',
        rows: [
          { label: 'بهای طرح تأمین‌کننده', value: '600,000' },
          { label: 'Retail MARKUP · +۳۰٪ (افزودنی با حاشیه سود بالا)', value: '+180,000', accent: 'success' },
          { label: 'مجموع مسافر', value: '780,000', strong: true },
        ],
        note: 'eSIM بهای انجام کار صفر دارد — QR توسط تأمین‌کننده تولید و هنگام تأیید تحویل می‌شود، پس کل نرخ افزوده به حاشیه سود می‌رود.',
      },
      {
        title: 'همان سفر · سیم‌کارت فیزیکی',
        rows: [
          { label: 'بهای طرح تأمین‌کننده', value: '600,000' },
          { label: 'ارسال', value: '100,000' },
          { label: 'Retail MARKUP · +۲۵٪ از ناخالص', value: '+175,000', accent: 'success' },
          { label: 'مجموع مسافر', value: '875,000', strong: true },
        ],
        note: 'سیم‌کارت‌های فیزیکی بهای ارسال و زمان آماده‌سازی ارسال را می‌افزایند — نسخه eSIM معمولاً فروش بهتری است وقتی گوشی مشتری از آن پشتیبانی می‌کند.',
      },
    ],
    related: ['visa', 'insurance', 'flights-search'],
  },

  insurance: {
    title: 'بیمه مسافرتی',
    tag: 'حفاظت سفر',
    tagline: 'بیمه‌نامه‌های مسافرتی قابل رزرو که به‌عنوان افزودنی به یک سفر فروخته می‌شوند.',
    business: {
      lead: 'بیمه مسافرتی از مشتری در برابر اختلال‌های سفر (تأخیر، لغو، پزشکی، بار) محافظت می‌کند و به آژانس یک خط درآمد جانبی می‌دهد. برخی مقصدها پوشش معتبر را به‌عنوان شرط ویزا الزامی می‌کنند، پس می‌تواند یک محصول تطابقی باشد نه صرفاً یک گزینه اختیاری.',
      points: [
        { title: 'هم اختیاری و هم اجباری وجود دارد', desc: 'برای برخی ویزاها پوشش برای واجد شرایط شدن الزامی است؛ برای سفرهای صرفاً تفریحی، یک گزینه اختیاری است که کارگزار هنگام بستن معامله بالافروشی می‌کند.' },
        { title: 'طرح‌های سطح‌بندی‌شده', desc: 'یک طرح با سقف پوشش و مدت آن تعریف می‌شود — مشتری سطحی را انتخاب می‌کند که با تحمل ریسک و بودجه‌اش بخواند.' },
        { title: 'ضمانت‌شده به‌صورت بیرونی', desc: 'پلتفرم بیمه‌نامه را ضمانت نمی‌کند — یک محصول شخص ثالث می‌فروشد و رکورد بیمه‌نامه حاصل را روی سفر مشتری ثبت می‌کند.' },
      ],
    },
    software: {
      lead: 'یک جستجوی مسافر + مقصد روی کاتالوگ بیمه متصل.',
      points: [
        { title: 'ترکیب پوشش', desc: 'مقصد، تاریخ‌های سفر و سن مسافران نتایج را هدایت می‌کنند؛ سطح پوشش طرح را محدود می‌کند.' },
        { title: 'خواندن ردیف طرح', desc: 'هر نتیجه، بیمه‌گر، سقف پوشش و قیمت را نشان می‌دهد؛ اسناد بیمه‌نامه هنگام انتخاب باز می‌شوند.' },
        { title: 'رزرو بیمه‌نامه', desc: 'انتخاب یک طرح، فرم مسافر و پرداخت را باز می‌کند؛ رکورد بیمه‌نامه و اسناد آن به سفر مشتری پیوست می‌شوند.' },
      ],
    },
    flow: {
      lead: 'یک رزرو بیمه‌نامه کوتاه است — مقصد، تاریخ‌های سفر، سن مسافران، سطح، پرداخت.',
      steps: [
        { title: 'انتخاب شکل سفر', desc: 'کشور / منطقه مقصد، تاریخ‌های سفر، و سن هر مسافر (نرخ با بازه سنی تغییر می‌کند).' },
        { title: 'انتخاب یک سطح پوشش', desc: 'پایه تنها موارد ضروری را پوشش می‌دهد؛ استاندارد بار / تأخیر را می‌افزاید؛ ممتاز پزشکی کامل + لغو سفر را می‌افزاید. متناسب با ارزش در معرض ریسک سفر انتخاب کنید.' },
        { title: 'خواندن طرح', desc: 'هر طرح سقف پوشش را به‌ازای هر خط (پزشکی، لغو، بار) و استثناها را فهرست می‌کند. اسناد بیمه‌نامه در همان صفحه باز می‌شوند.' },
        { title: 'ثبت مسافران + پرداخت', desc: 'نام مسافران، تاریخ تولد و شماره پاسپورت + پرداخت؛ بیمه‌نامه هنگام رزرو صادر می‌شود.' },
        { title: 'دریافت اسناد بیمه‌نامه', desc: 'PDF بیمه‌نامه + گواهی به رزرو پیوست می‌شوند. برخی مقصدها گواهی را هنگام ثبت در سفارتخانه الزامی می‌کنند.' },
      ],
    },
    modes: {
      lead: 'بیمه بر اساس دو محور قیمت‌گذاری می‌شود — سطح پوشش (چه چیزی پوشش داده می‌شود) و شکل سفر (تک‌سفر در برابر سالانه).',
      modes: [
        { name: 'سطح پایه', when: 'سفرهای داخلی / تفریحی کوتاه', desc: 'اورژانس پزشکی + بازگردانی. بار و لغو شامل نمی‌شوند. ارزان‌ترین حق بیمه.' },
        { name: 'سطح استاندارد', when: 'بیشتر سفرهای تفریحی', desc: 'گم شدن بار، تأخیر سفر و لغو محدود را می‌افزاید. پرفروش‌ترین سطح.' },
        { name: 'سطح ممتاز', when: 'سفرهای گران یا مسافران مسن‌تر', desc: 'پزشکی کامل (سقف بالاتر)، لغو کامل به هر دلیل، فعالیت‌های ماجراجویانه را می‌افزاید. بالاترین حق بیمه.' },
        { name: 'تک‌سفر', when: 'یک سفر در هفته‌های پیش رو', desc: 'یک بازه تاریخ مشخص (شروع ← پایان سفر) را پوشش می‌دهد. ارزان‌ترین برای مسافران گاه‌به‌گاه.' },
        { name: 'چندسفر سالانه', when: 'سفر مکرر کاری یا تفریحی', desc: 'هر سفر در یک سال را تا سقف طول هر سفر (معمولاً ۳۰ تا ۶۰ روز) پوشش می‌دهد. برای بیش از ۳ سفر در سال ارزان‌تر از خرید تک‌سفر هر بار.' },
      ],
    },
    examples: [
      {
        title: 'ترکیه · سفر ۱۰ روزه · سطح استاندارد · ۲ بزرگسال + ۱ کودک',
        rows: [
          { label: 'حق بیمه پایه (بزرگسال) × ۲', value: '1,400,000' },
          { label: 'حق بیمه پایه (کودک)', value: '400,000' },
          { label: 'جمع جزء', value: '1,800,000' },
          { label: 'Retail MARKUP · +۲۰٪ کارمزد', value: '+360,000', accent: 'success' },
          { label: 'مجموع مسافر', value: '2,160,000', strong: true },
        ],
        note: 'کارمزد بیمه معمولاً ۱۵ تا ۲۵٪ حق بیمه است — یک حاشیه سود جانبی محکم در هر رزرو، و یک بیمه‌نامه همه افراد سفر را پوشش می‌دهد.',
      },
    ],
    related: ['visa', 'sim', 'flights-search'],
  },

  bookings: {
    title: 'همه رزروها',
    tag: 'دفتر سفارش',
    tagline: 'هر سفارشی که آژانس ثبت کرده، در هر محصول، در یک فهرست.',
    business: {
      lead: 'همه رزروها رکورد عملیاتی همه فروخته‌شده‌ها است — پروازها، هتل‌ها، تورها، حمل‌ونقل، ویزاها، CIP — به‌صورت سفارش‌های یکپارچه. اینجا جایی است که کارکنان رزرو یک مشتری را برای خدمات‌رسانی پیدا می‌کنند: صدور مجدد، افزودن اضافات، لغو، استرداد یا صرفاً بررسی وضعیت آن.',
      points: [
        { title: 'یک سفارش، محصولات متعدد', desc: 'یک سفارش واحد می‌تواند یک پرواز، یک هتل و یک افزودنی را گرد آورد — هرکدام یک قلم زیر همان شماره رزرو / PNR است.' },
        { title: 'وضعیت به شما می‌گوید چه کنید', desc: 'پیش‌نویس ← نگه‌داشته ← تأییدشده ← پرداخت‌شده، به‌همراه در حال بازبینی (یک اقامت درخواستی در انتظار تأیید) و لغوشده — نشان، جایگاه رزرو را نمایش می‌دهد.' },
        { title: 'سطح خدمات‌رسانی', desc: 'هر اقدام پس از فروش (لغو، استرداد، هزینه‌ها، مدارک) با پیدا کردن سفارش اینجا آغاز می‌شود.' },
      ],
    },
    software: {
      lead: 'یک جدول قابل جستجو و فیلتر از سفارش‌ها — و هدف جستجوی سراسری نوار بالا.',
      points: [
        { title: 'یافتن سریع', desc: 'جستجو بر اساس شماره رزرو، PNR، مسافر یا مخاطب؛ فیلتر بر اساس محصول، وضعیت یا تاریخ.' },
        { title: 'جستجوی سراسری اینجا فرود می‌آید', desc: 'یک جستجوی نوار بالا که یک نتیجه یکتا نباشد، تطبیق‌هایش را اینجا فهرست می‌کند؛ یک نتیجه یکتا مستقیم به جزئیات رزرو می‌پرد.' },
        { title: 'باز کردن برای خدمات‌رسانی', desc: 'روی یک ردیف کلیک کنید تا جزئیات کامل رزرو باز شود و روی آن اقدام کنید.' },
      ],
    },
    lifecycles: {
      kicker: 'چرخه وضعیت',
      title: 'وضعیت بر اساس محصول',
      successPrefix: 'موفقیت',
      fromLabel: 'از',
      lead: 'هر سفارش روی یک ستون فقرات مشترک حرکت می‌کند — ایجاد، پرداخت، سپس تحقق — اما حالت «تحقق‌یافته» بر اساس آنچه محصول ارائه می‌دهد نام‌گذاری می‌شود. حمل‌ونقل یک سند سفر صادر می‌کند، پس حالت موفقیت آن «بلیت صادرشده» است. هتل‌ها و بیشتر خدمات یک رزرو بدون بلیت را قطعی می‌کنند، پس حالت آن‌ها «تأییدشده» است. ویزا به‌جای صدور بلیت یا تأیید، «تعیین تکلیف» می‌شود، پس حالت موفقیت آن «تأییدشده (صدور)» است. هر سه یک نقطه‌عطف یکسان‌اند: فروش قطعی است و یک سند فروش حسابداری ثبت می‌شود. از آن‌جا یک رزرو می‌تواند لغو و مسترد شود، و مسیرهای ناموفق (شکست پرداخت، انقضای نگه‌داشت، رد توسط اپراتور، رد ویزا) در حالت‌های پایانی خودشان پایان می‌یابند.',
      legend: [
        { label: 'در جریان', kind: 'neutral' },
        { label: 'در انتظار اقدام', kind: 'warn' },
        { label: 'فروش قطعی ← سند صادر می‌شود', kind: 'success' },
        { label: 'مسیر ناموفق / پایانی', kind: 'danger' },
      ],
      items: [
        {
          product: 'پروازها، قطارها و اتوبوس‌ها',
          success: 'بلیت صادرشده',
          lead: 'حمل‌ونقل موجودی را به‌صورت یک PNR نگه می‌دارد، سپس یک بلیت شماره‌دار صادر می‌کند. «بلیت صادرشده» نقطه بی‌بازگشت است — سند صادر شده و فروش ثبت می‌شود.',
          path: [
            { status: 'پیش‌نویس', kind: 'neutral', note: 'سبد ساخته شد' },
            { status: 'نگه‌داشته', kind: 'warn', note: 'PNR یک صندلی را نگه می‌دارد' },
            { status: 'در انتظار پرداخت', kind: 'neutral' },
            { status: 'بلیت صادرشده', kind: 'success', note: 'بلیت الکترونیکی / PNR صادر شد · سند ثبت می‌شود' },
          ],
          branches: [
            { from: 'نگه‌داشته', nodes: [{ status: 'منقضی‌شده', kind: 'danger' }], desc: 'پنجره نگه‌داشت منقضی می‌شود (یک جاروبگر تقریباً هر ۶۰ ثانیه اجرا می‌شود) و صندلی به تأمین‌کننده بازگردانده می‌شود.' },
            { from: 'در انتظار پرداخت', nodes: [{ status: 'ناموفق', kind: 'danger' }], desc: 'پرداخت رد می‌شود یا کرایه تأمین‌کننده هنگام تلاش مجدد منقضی می‌شود — چیزی صادر نمی‌شود.' },
            { from: 'بلیت صادرشده', nodes: [{ status: 'لغوشده', kind: 'danger' }, { status: 'مستردشده', kind: 'neutral' }], desc: 'پس از فروش: یک برآورد لغو اجرا می‌شود، سپس هر پول دریافت‌شده منهای جریمه بازگردانده می‌شود.' },
          ],
        },
        {
          product: 'هتل‌ها',
          success: 'تأییدشده',
          lead: 'یک هتل هرگز بلیت صادر نمی‌کند — یک تأییدیه بازمی‌گرداند، نه یک سند. اقامتگاه‌های آنی با پرداخت تأیید می‌شوند؛ اقامتگاه‌های درخواستی ابتدا کارت را مجاز می‌کنند و منتظر اپراتور (در حال بازبینی) می‌مانند و سپس مبلغ برداشت می‌شود.',
          path: [
            { status: 'پیش‌نویس', kind: 'neutral', note: 'سبد ساخته شد' },
            { status: 'در انتظار پرداخت', kind: 'neutral', note: 'آنی: پرداخت برای تأیید' },
            { status: 'تأییدشده', kind: 'success', note: 'رزرو قطعی شد · سند ثبت می‌شود' },
          ],
          branches: [
            { from: 'در انتظار پرداخت', label: 'درخواستی', nodes: [{ status: 'در حال بازبینی', kind: 'warn', note: 'اپراتور تصمیم می‌گیرد' }, { status: 'تأییدشده', kind: 'success' }], desc: 'کارت مجاز می‌شود، درخواست نزد اپراتور می‌ماند؛ با تأیید، مبلغ برداشت و اقامت تأیید می‌شود.' },
            { from: 'در حال بازبینی', nodes: [{ status: 'ردشده', kind: 'danger' }], desc: 'اپراتور رد می‌کند — مجوز پرداخت باطل می‌شود، پس هیچ مبلغی برداشت نمی‌شود.' },
            { from: 'تأییدشده', nodes: [{ status: 'لغوشده', kind: 'danger' }, { status: 'مستردشده', kind: 'neutral' }], desc: 'لغو پس از فروش طبق قوانین نرخ انجام می‌شود؛ استرداد، پول دریافت‌شده را منهای جریمه بازمی‌گرداند.' },
          ],
        },
        {
          product: 'تورها و سایر خدمات مستقیم (CIP، ترانسفر، سیم‌کارت، بیمه)',
          success: 'تأییدشده',
          lead: 'محصولات خدماتی مستقیم یک سند/تأییدیه صادر می‌کنند، نه بلیت، پس در «تأییدشده» کامل می‌شوند. یک تور یک پرواز + هتل را گرد می‌آورد اما با یک قیمت فروش مستقل از تأمین‌کننده فروخته می‌شود — یک سفارش، یک سند. (CIP، ترانسفر، سیم‌کارت و بیمه مدل‌سازی شده‌اند اما هنوز فعال نیستند.)',
          path: [
            { status: 'پیش‌نویس', kind: 'neutral', note: 'سبد ساخته شد' },
            { status: 'در انتظار پرداخت', kind: 'neutral' },
            { status: 'تأییدشده', kind: 'success', note: 'خدمت قطعی شد · سند ثبت می‌شود' },
          ],
          branches: [
            { from: 'در انتظار پرداخت', nodes: [{ status: 'ناموفق', kind: 'danger' }], desc: 'پرداخت رد می‌شود — خدمت تأیید نمی‌شود.' },
            { from: 'تأییدشده', nodes: [{ status: 'لغوشده', kind: 'danger' }, { status: 'مستردشده', kind: 'neutral' }], desc: 'لغو و استرداد پس از فروش، طبق قوانین لغو محصول.' },
          ],
        },
        {
          product: 'ویزا',
          success: 'تأییدشده (صدور)',
          lead: 'ویزا به‌جای صدور بلیت یا تأیید معمول، تعیین تکلیف می‌شود: درخواست ثبت می‌شود، در حال بررسی می‌ماند و سپس تأیید یا رد می‌شود. «تأییدشده (صدور)» حالت موفقیت ویزاست — همان نقطه‌عطف «فروش قطعی» مانند تأییدشده — و سند فروش را ثبت می‌کند. به سه حالت خلاصه می‌شود: در حال بررسی ← تأیید / رد.',
          path: [
            { status: 'پیش‌نویس', kind: 'neutral', note: 'درخواست ساخته شد' },
            { status: 'در انتظار پرداخت', kind: 'neutral' },
            { status: 'در حال بررسی', kind: 'warn', note: 'در حال پردازش' },
            { status: 'تأییدشده (صدور)', kind: 'success', note: 'ویزا صادر شد · سند ثبت می‌شود' },
          ],
          branches: [
            { from: 'در حال بررسی', nodes: [{ status: 'ردشده', kind: 'danger' }], desc: 'درخواست رد می‌شود — سندی ثبت نمی‌شود. شکست پرداخت یا لغو ویزا نیز به «ردشده» می‌رسد.' },
          ],
        },
      ],
    },
    examples: [
      {
        title: 'یک پرواز که کامل می‌شود',
        rows: [
          { label: 'سبد ساخته شد', value: 'پیش‌نویس' },
          { label: 'صندلی نگه‌داشته شد (PNR)', value: 'نگه‌داشته', accent: 'info' },
          { label: 'مشتری پرداخت می‌کند', value: 'در انتظار ← پرداخت‌شده' },
          { label: 'بلیت صادر شد', value: 'بلیت صادرشده', strong: true, accent: 'success' },
        ],
        note: 'سفارش در همان لحظه‌ای که بلیت صادر می‌شود واجد شرایط حسابداری می‌شود — سند فروش از همان رویداد تنظیم می‌شود. قطارها و اتوبوس‌ها همین مسیر را دنبال می‌کنند.',
      },
      {
        title: 'یک هتل درخواستی',
        rows: [
          { label: 'رزرو شد، کارت مجاز شد', value: 'در انتظار پرداخت' },
          { label: 'اپراتور درخواست را بررسی می‌کند', value: 'در حال بازبینی', accent: 'info' },
          { label: 'اپراتور تأیید می‌کند ← برداشت', value: 'تأییدشده', strong: true, accent: 'success' },
        ],
        note: 'اگر اپراتور رد کند، وضعیت به ردشده می‌رود و مجوز پرداخت باطل می‌شود — هیچ مبلغی برداشت نمی‌شود. یک اقامتگاه آنی مرحله در حال بازبینی را رد می‌کند و با پرداخت تأیید می‌شود.',
      },
      {
        title: 'یک تور (فروش بسته‌ای)',
        rows: [
          { label: 'بسته رزرو شد', value: 'در انتظار پرداخت' },
          { label: 'تأییدشده — سند صادر شد', value: 'تأییدشده', strong: true, accent: 'success' },
        ],
        note: 'یک تور یک پرواز + هتل را بسته‌بندی می‌کند اما به‌صورت یک فروش مستقل از تأمین‌کننده با یک قیمت واحد ثبت می‌شود — تأییدشده، هرگز بلیت صادرشده.',
      },
    ],
    related: ['booking-detail', 'queue', 'refunds', 'counter'],
  },

  'booking-detail': {
    title: 'جزئیات رزرو',
    tag: 'رکورد سفارش',
    tagline: 'رکورد کامل پنج‌لایه یک سفارش — اقلام، پول، پرداخت‌ها، مدارک و اقدامات.',
    business: {
      lead: 'یک رزرو در پنج لایه مدل می‌شود — سفارش ← قلم ← مرجع تأمین‌کننده ← مدرک ← کوپن — تا هر کرایه، مالیات، کارمزد و استرداد دقیقاً به چیزی که به آن تعلق دارد نسبت داده شود. این صفحه جایی است که یک سفارش سرتاسری درک و خدمات‌رسانی می‌شود.',
      points: [
        { title: 'پنج لایه، نسبت‌دهی دقیق', desc: 'پول از کوپن‌ها و مدارک به اقلام و سپس سفارش جمع می‌شود، پس همیشه می‌دانید چه کسی چه بدهکار است.' },
        { title: 'لغو در هر سطح', desc: 'یک کوپن، یک مدرک، یک قلم، یا کل سفارش را لغو کنید — همیشه با یک برآورد پیش از هر جابه‌جایی پول.' },
        { title: 'درخواستی اینجا است', desc: 'یک درخواست هتل معلق (در حال بازبینی) یک نوار تأیید / رد نشان می‌دهد — تأیید، پرداخت مجازشده را دریافت می‌کند، رد آن را باطل می‌کند.' },
      ],
    },
    software: {
      lead: 'یک رکورد زبانه‌بندی‌شده با اطلاعات مالی هر سطح و اقدامات پس از فروش.',
      points: [
        { title: 'اقلام', desc: 'تفکیک قلم‌به‌قلم — هر محصول به‌عنوان یک قلم با بخش‌ها / اتاق‌ها، مسافران و وضعیت آن.' },
        { title: 'اطلاعات مالی', desc: 'ماتریس پول: خالص، نرخ‌های افزوده، مالیات‌ها، کارمزدها، تخفیف‌ها، کارمزدها و حاشیه سود در هر سطح.' },
        { title: 'پرداخت‌ها', desc: 'بخش‌های پرداخت (مجازشده / دریافت‌شده / مستردشده / باطل‌شده) و مانده قابل پرداخت.' },
        { title: 'مدارک', desc: 'مدارک تأمین‌کننده صادرشده؛ یک بلیت الکترونیکی پرواز، واچر بلیت پرواز دوزبانه و آماده چاپ را باز می‌کند، و اسکن‌های آژانس قابل پیوست هستند.' },
        { title: 'هزینه‌ها', desc: 'هزینه‌های پس از رزرو — افزودن کارمزد، خدمات جانبی، جریمه یا تخفیف، و اصلاحات ساختاری (افزودن مسافر / قلم، تصحیح نام) با VAT.' },
        { title: 'تیکت‌ها', desc: 'تیکت‌های پشتیبانی که روی اقلام این رزرو بین آژانس و میز پلتفرم مطرح شده‌اند.' },
        { title: 'لغو و استرداد', desc: 'برآورد و اجرای یک لغو در هر سطح؛ استردادها به گردش‌کار تأیید استرداد و ابطال مسیریابی می‌شوند.' },
      ],
    },
    examples: [
      {
        title: 'چگونه پول جمع می‌شود (یک قلم هتل)',
        rows: [
          { label: 'خالص تأمین‌کننده', value: '7,400,000' },
          { label: '+ نرخ افزوده Retail', value: '+1,110,000', accent: 'info' },
          { label: '+ خدمات جانبی و VAT', value: '+990,000', accent: 'success' },
          { label: 'مجموع فروش', value: '9,500,000', strong: true, accent: 'accent' },
          { label: '− پرداخت‌شده', value: '9,500,000' },
          { label: 'مانده قابل پرداخت', value: '0', strong: true },
        ],
        note: 'مجموع سفارش، جمع اقلام آن است؛ مجموع فروش هر قلم، خالص آن به‌همراه لایه‌های نرخ افزوده، هزینه‌ها و مالیات‌های نسبت‌داده‌شده به آن است.',
      },
    ],
    related: ['bookings', 'refunds', 'queue'],
  },

  queue: {
    title: 'صف رزرو',
    tag: 'نگه‌داشتن PNR',
    tagline: 'PNRهایی که موجودی را نگه داشته‌اند و هنوز به صدور بلیت یا اقدام تأمین‌کننده نیاز دارند.',
    business: {
      lead: 'یک PNR نگه‌داشته موجودی را رزرو می‌کند اما هنوز بلیت آن صادر نشده — یک تعهد با مهلت است. صف این‌ها را نمایش می‌دهد تا کارکنان پیش از انقضای نگه‌داشتن اقدام کنند و صندلی یا اتاق به‌صورت خودکار به تأمین‌کننده بازگردانده نشود.',
      points: [
        { title: 'نگه‌داشتن‌ها فسادپذیرند', desc: 'PNRهای بدون بلیت هنگام سپری شدن بازه نگه‌داشتن به‌صورت خودکار لغو می‌شوند (یک جاروکش هر ۶۰ ثانیه اجرا می‌شود) و موجودی را آزاد می‌کنند.' },
        { title: 'از زمان جلو بزنید', desc: 'زمان تا صدور بلیت، سنجه‌ای است که اهمیت دارد — به‌موقع صادر کنید وگرنه رزرو از دست می‌رود.' },
        { title: 'تنها صدور بلیت نیست', desc: 'برخی ردیف‌ها منتظر یک تأمین‌کننده (مثلاً یک تأیید درخواستی) هستند، نه فقط اقدام صدور شما.' },
      ],
    },
    software: {
      lead: 'یک فهرست کاری مرتب‌شده بر اساس زمان از نگه‌داشتن‌ها با مهلت‌هایشان.',
      points: [
        { title: 'ببینید چه چیزی در حال انقضا است', desc: 'هر ردیف انقضای نگه‌داشتن خود را نشان می‌دهد، پس فوری‌ترین‌ها به بالا شناور می‌شوند.' },
        { title: 'اقدام روی یک ردیف', desc: 'رزرو را باز کنید تا بلیت صادر کنید یا اقدام تأمین‌کننده لازم را انجام دهید.' },
        { title: 'لغو خودکار، خودکار است', desc: 'نگه‌داشتن‌های منقضی توسط جاروکش پس‌زمینه آزاد می‌شوند و از صف خارج می‌گردند.' },
      ],
    },
    related: ['bookings', 'booking-detail'],
  },

  refunds: {
    title: 'استردادها و ابطال‌ها',
    tag: 'پول پس از فروش',
    tagline: 'گردش‌کار کنترل‌شده برای بازگرداندن پول — لغوها، استردادها و ابطال‌ها.',
    business: {
      lead: 'وقتی یک رزرو لغو می‌شود، پول باید به‌درستی و تحت کنترل بازگردد. استردادها و ابطال‌ها جایی است که درخواست‌ها مطرح و تأیید می‌شوند، تا استردادها از قواعد کرایه پیروی کنند و هیچ چیز بدون بررسی خارج نشود.',
      points: [
        { title: 'آغاز در برابر تأیید', desc: 'مطرح کردن یک استرداد و تأیید آن گام‌های جداگانه‌اند — تأیید، دروازه جابه‌جایی پول است که پشت مجوز خاص خود نگه داشته می‌شود.' },
        { title: 'ابطال در برابر استرداد', desc: 'یک ابطال، مجوزی را که هرگز دریافت نشده لغو می‌کند (چیزی برداشت نشده)؛ یک استرداد، پول دریافت‌شده را کمتر از هر جریمه بازمی‌گرداند.' },
        { title: 'قواعد، نه حدس', desc: 'مبالغ از قواعد کرایه / لغو و هر جریمه پیروی می‌کنند؛ درخواست، تفکیک را ثبت می‌کند.' },
      ],
    },
    software: {
      lead: 'یک صف از درخواست‌های استرداد / ابطال با وضعیت و مبالغشان.',
      points: [
        { title: 'کار روی صف', desc: 'درخواست‌های معلق را با مبلغ، جریمه و دلیلشان ببینید.' },
        { title: 'تأیید یا رد', desc: 'تأیید کنید تا پول جابه‌جا شود (استرداد دریافت / ابطال مجوز) یا با یک دلیل رد کنید.' },
        { title: 'قابل ردیابی', desc: 'هر تصمیم نسبت داده می‌شود و به رزرو منشأ گره می‌خورد.' },
      ],
    },
    related: ['booking-detail', 'bookings'],
  },

  counter: {
    title: 'باجه',
    tag: 'نقد و POS',
    tagline: 'شیفت‌های صندوقدار، جابه‌جایی‌های نقد و POS، و تطبیق پایان روز.',
    business: {
      lead: 'برای آژانس‌هایی که روی یک باجه فیزیکی می‌فروشند، این لایه کنترل نقدینگی است: ردیابی می‌کند چه کسی در شیفت است، هر جابه‌جایی نقد و کارت، و صندوق را در پایان روز موازنه می‌کند تا دریافتی‌ها با رکورد بخوانند.',
      points: [
        { title: 'پاسخ‌گویی در هر شیفت', desc: 'باز و بسته کردن یک شیفت، هر جابه‌جایی را به یک صندوقدار و یک نشست گره می‌زند.' },
        { title: 'انضباط نقدی', desc: 'ثبت جابه‌جایی‌های نقد و POS همان‌طور که رخ می‌دهند، همان چیزی است که تطبیق پایان روز را ممکن می‌کند.' },
        { title: 'تطبیق کنید، حدس نزنید', desc: 'پایان روز، مورد انتظار را با شمرده‌شده مقایسه می‌کند، پس یک مغایرت بلافاصله نمایان می‌شود.' },
      ],
    },
    software: {
      lead: 'یک داشبورد برای شیفت جاری با جابه‌جایی‌ها و تطبیق آن.',
      points: [
        { title: 'باز / بسته کردن یک شیفت', desc: 'یک نشست را آغاز کنید تا ثبت شروع شود؛ آن را ببندید تا تطبیق شود.' },
        { title: 'ثبت جابه‌جایی‌ها', desc: 'نقد ورودی / خروجی و تراکنش‌های POS را در طول شیفت ثبت کنید.' },
        { title: 'تطبیق هنگام بستن', desc: 'مورد انتظار را با شمرده‌شده مقایسه کنید و مغایرت را ثبت کنید.' },
      ],
    },
    related: ['bookings', 'refunds'],
  },
};
